import {RouteObject} from 'react-router-native';
import {COMMON_ROUTE_CONFIG, RouteHandle} from './routes.config.common';

const ROUTE_CONFIG: ReadonlyArray<RouteObject & {handle: RouteHandle}> = COMMON_ROUTE_CONFIG;

export {COMMON_ROUTE_CONFIG, ROUTE_CONFIG};
export type {RouteHandle};
